import Card from '../components/common/Card';
import RSVPForm from '../components/forms/RSVPForm';

export default function RSVP() {
  return (
    <div className="min-h-screen py-16 bg-gradient-to-br from-pink-light via-lavender-light to-mint-light">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl md:text-5xl text-center mb-6 text-gray-800">
          RSVP
        </h1>
        <p className="text-center text-lg text-gray-700 mb-12">
          We're excited to celebrate with you! Please let us know if you can join us.
        </p>

        <Card>
          <RSVPForm />
        </Card>

        <div className="mt-8 text-center">
          <p className="text-gray-600">
            <strong>RSVP Deadline:</strong> 23rd February 2026
          </p>
        </div>
      </div>
    </div>
  );
}
